import React from 'react'
import { FormattedMessage } from 'react-intl'
import { Box, Typography } from '@material-ui/core'
import { Image, Transformation } from 'cloudinary-react'
import { MEDIUM_SIZE } from 'assets/CloudinaryURLHelper'
import Button from 'components/Button/Button'
import LocaleHelper from 'assets/LocaleHelper'
import { useStyles } from '../IntegrationIndexPage_style'

const IntegrationItem = ({ integration, onContactClick }) => {
    const classes = useStyles()
    const currentLocale = LocaleHelper.getCurrentLocale()

    const getDescription = () => {
        return integration[`description_${currentLocale}`]
    }

    return (
        <Box className={classes.cardWrapper}>
            <Box className={classes.card}>
                <Box className={classes.cardContent}>
                    <Box className={classes.logoAndName}>
                        <Box className={classes.logoBox}>
                            <Image
                                className={classes.logo}
                                cloudName='studentbe'
                                publicId={integration.logo.cloudinary_key}
                                alt={integration.name}
                            >
                                <Transformation flags='progressive' fetchFormat='auto' width={MEDIUM_SIZE} quality='auto:best' crop='fill' />
                            </Image>
                        </Box>
                        <Typography variant='h3' className={classes.integrationName}>
                            {integration.name}
                        </Typography>
                    </Box>
                    <Typography variant='body1' className={classes.description}>
                        {getDescription()}
                    </Typography>
                    <Box className={classes.buttonBox}>
                        <Button
                            variant='secondary'
                            size='medium'
                            className={classes.button}
                            onClick={onContactClick}
                        >
                            <FormattedMessage id='integrations_catalogue.contact_us' />
                        </Button>
                    </Box>
                </Box>
            </Box>
        </Box>
    )
}

export default IntegrationItem
